import axios from "axios";
import { toast } from "react-toastify";
import { toastProperties } from "../commons/Toast/Toaster";

// Create axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("OTC_V2_TOKEN");
    if (token) {
      config.headers.Authorization = ` ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// GET request
export const getApi = async (
  url,
  headers = {},
  showSuccess = false,
  responseType = "json"
) => {
  try {
    const config = {
      headers,
      responseType,
    };

    // Apply transformResponse ONLY for blobs
    if (responseType === "blob") {
      config.transformResponse = (r) => r;
    }

    const response = await api.get(url, config);
    return response;
  } catch (error) {
    return error.response || error;
  }
};

// POST request
export const postApi = async (
  url,
  data = {},
  config = {},
  showSuccess = true,
  responseType = "json" // Add responseType param
) => {
  try {
    const isFormData = data instanceof FormData;

    const axiosConfig = {
      ...config,
      headers: {
        ...(isFormData ? { "Content-Type": "multipart/form-data" } : {}),
        ...(config.headers || {}),
      },
      responseType, // Add responseType to config
    };

    // Apply transformResponse ONLY for blobs
    if (responseType === "blob") {
      axiosConfig.transformResponse = (r) => r;
    }

    const response = await api.post(url, data, axiosConfig);

    if (response?.data?.code === 200) {
      //toast.success(response.data.message, toastProperties);
      return response;
    } else {
      // toast.error(response?.data?.error, toastProperties);
      return response;
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      "Failed to create data";
    toast.error(errorMessage, toastProperties);
    return error;
  }
};

// PUT request
export const putApi = async (
  url,
  data = {},
  headers = {},
  showSuccess = true
) => {
  try {
    const response = await api.put(url, data, { headers });
    if (showSuccess && response.data?.message) {
      // //toast.success(response.data.message, toastProperties);
    }
    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to update data";
    toast.error(errorMessage, toastProperties);
  }
};

// DELETE request
export const deleteApi = async (
  url,
  data = null,
  headers = {},
  showSuccess = true
) => {
  try {
    const config = { headers };
    if (data !== null) {
      config.data = data;
    }
    const response = await api.delete(url, config);
    if (showSuccess && response.data?.message) {
      // toast.success(response.data.message, toastProperties);
      // toast.success(response.data.message, toastProperties);
    }
    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete data";
    toast.error(errorMessage, toastProperties);
    throw error; // Re-throw to allow caller to handle
  }
};

export const patchApi = async (
  url,
  data = {},
  headers = {},
  showSuccess = true
) => {
  try {
    const response = await api.patch(url, data, { headers });
    if (showSuccess && response.data?.message) {
      //toast.success(response.data.message, toastProperties);
    }
    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to update data";
    toast.error(errorMessage, toastProperties);
  }
};

// Success message handler
export const showSuccessMessage = (message) => {
  //toast.success(message, toastProperties);
};

// Error message handler
export const showErrorMessage = (message) => {
  //toast.error(message, toastProperties);
};
